/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { AdminSelect } from '@project/components';
import axios from '../../utils/axios';
import { useIntl } from 'react-intl';

const SpaceSelect = ({ selectedCompany = {}, selectedProperty = {}, selectedSpace, setSelectedSpace, selectClass }) => {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({id});

  const [spaces, setSpaces] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const company = selectedCompany ? selectedCompany.value : "";
  const property = selectedProperty ? selectedProperty.value : "";

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        setSelectedSpace(null);
        setSpaces([]);
        if (!(selectedProperty && selectedProperty.value)) return;
        setIsLoading(true);
        const result = await axios.get(`/space-profile-assets/${encodeURIComponent(selectedCompany.value)}/${encodeURIComponent(selectedProperty.value)}`);
        let spaces = result.data.records.filter(_ => _.spaceNumber);
        spaces = spaces.sort((a, b) => ('' + a.spaceNumber).localeCompare(b.spaceNumber))
          .sort((a, b) => parseInt(a.spaceNumber) - parseInt(b.spaceNumber))

        const spaceOptions = spaces.map(space => ({
          value: space.spaceNumber,
          label: space.spaceStatus && space.spaceProfileGuid ? `${space.spaceNumber} - ${t('CreateNewProfile.hasProfile')}` : space.spaceNumber,
          assetGuid: space.assetGuid,
          spaceProfileGuid: space.spaceProfileGuid,
          spaceStatus: space.spaceStatus
        }))
        
        setIsLoading(false);
        setSpaces(spaceOptions);
      } catch (e) {

      }
    }
    fetchProperties();
  }, [company, property]);

  return (
    <AdminSelect 
      id={`${property}-${company}-space`}
      label={t('term.unit_no')}
      value={selectedSpace}
      onChange={setSelectedSpace}
      options={spaces}
      isLoading={isLoading}
      loadingMessage={t('CompanySelect.loadingMessage')}
      noOptionsMessage={t('CompanySelect.noOptions')}
      placeholder={isLoading ? `${t('ui.loading')}...` : t('SpaceSelect.placeholder')}
      identifierClass={ !isLoading ? 'data-space-select' : ''}
    />
  )
};

export default SpaceSelect;
